import { createRequestConstantNames } from 'store/util/createConstants';
import cc from 'store/util/createReduxConstant';

export const [
  FETCH_COMPANY_STATS,
  FETCH_COMPANY_STATS_SUCCESS,
  FETCH_COMPANY_STATS_FAIL,
] = createRequestConstantNames(cc('FETCH_COMPANY_STATS'));
